import { InferenceStore } from 'store/inference/InferenceStore'
import ProfileStore from 'store/profile/ProfileStore'
import { store } from 'store/store'
import { parseDate } from 'util/date'
import { load, save } from 'util/storage'

const DAY = 24 * 60 * 60 * 1000

export function needPersonalize(inference: InferenceStore | undefined): ProfileStore | undefined {
  if (!inference) return

  const { identity_id, complete } = inference
  if (!identity_id || !complete) return

  const full = store.identities.profiles.find(it => it.identity_id
    && it.identity_id === identity_id && it.type === 'full')
  if (!full) return

  const user_url = full.common.userPhoto.url
  if (!user_url) return

  const dont = loadDont(identity_id)
  if (dont) return

  const cancel = loadCancel(identity_id)
  if (cancel && Date.now() < cancel.getTime() + DAY) return

  const params = new URL(user_url, location.origin).searchParams
  return params.has('asset') ? full : undefined
}

export function saveDont(identity_id: string) {
  if (!identity_id) return
  save(`personalize.dont.${identity_id}`, 'true')
}

export function loadDont(identity_id: string): boolean {
  return load(`personalize.dont.${identity_id}`) === 'true'
}

export function saveCancel(identity_id: string) {
  save(`personalize.cancel.${identity_id}`, new Date().toISOString())
}

export function loadCancel(identity_id: string): Date | undefined {
  return parseDate(load(`personalize.cancel.${identity_id}`))
}
